import { cn } from "../../shadCn/lib/utils"

function Skeleton({
                      className,
                      ...props
                  }) {
    return (<div className={cn("animate-pulse bg-gray-200 rounded", className)} {...props} />);
}

export { Skeleton }
